import React from 'react';
import { Badge, Tooltip, Box } from '@chakra-ui/react';

function resolveSchoolFrom(student) {
  if (!student) return null;
  return student.schoolFrom ?? student.attributes?.schoolFrom ?? null;
}

export function isSchoolStudent(student) {
  const from = resolveSchoolFrom(student);
  const id = from?.id ?? from?.data?.id ?? null;
  return Boolean(id);
}

export function getSchoolLabel(student) {
  const from = resolveSchoolFrom(student);
  if (!from) return null;
  return (
    from.name ||
    from.attributes?.name ||
    from.data?.attributes?.name ||
    null
  );
}

export default function SchoolBadge({ student, ml = 2, ...rest }) {
  if (!isSchoolStudent(student)) return null;

  const label = getSchoolLabel(student);

  const badge = (
    <Badge
      colorScheme="purple"
      variant="subtle"
      textTransform="none"
      fontWeight="500"
      fontSize="11px"
      px={2}
      py={0.5}
      borderRadius="full"
      ml={ml}
      {...rest}
    >
      Convenio
    </Badge>
  );

  if (!label) return badge;

  return (
    <Tooltip label={label} hasArrow placement="top">
      <Box as="span" display="inline-flex" alignItems="center">
        {badge}
      </Box>
    </Tooltip>
  );
}
